import { render, staticRenderFns } from "./FarmProfile.vue?vue&type=template&id=23ba1fde&scoped=true&"
import script from "./FarmProfile.vue?vue&type=script&lang=js&"
export * from "./FarmProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba1fde",
  null
  
)

export default component.exports